import { Card, CardHeader, CardBody, Container, Row, Col } from "reactstrap";
import { useState } from "react";
import axios from "axios";
import Header from "components/Headers/Header";
import Cookies from "universal-cookie";
import ReactModal from "react-modal";
import Swal from "sweetalert2";

const ContratosFirmadosCliente = (props) => {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [isLoading, setLoading] = useState(false);

  const handleOpenModalTest = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const zIndexFix = () => {
    setTimeout(() => {
      const container = document.querySelector(".swal2-container");
      const popup = document.querySelector(".swal2-popup");
      if (container) container.style.zIndex = "9999";
      if (popup) popup.style.zIndex = "10000";
    }, 50);
  };

  const confirmarFirma = async () => {
    Swal.fire({
      title: "¿Confirmar firma?",
      text: "¿Está seguro que desea confirmar la firma del contrato?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sí, confirmar",
      cancelButtonText: "Cancelar",
      willOpen: zIndexFix,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true);
        try {
          const response = await axios.post(
            `https://contratosback.azurewebsites.net/api/v1/AdjuntaFirmados/${props.id}`,
          );

          Swal.fire({
            icon: "success",
            title: "¡Firmado!",
            text: "Se ha confirmado la firma correctamente.",
            willOpen: zIndexFix,
            timer: 2000,
            showConfirmButton: false,
          }).then(() => {
            closeModal();
          });
        } catch (error) {
          console.error("Error al confirmar la firma:", error);
          Swal.fire({
            icon: "error",
            title: "Error al firmar",
            text: error.message || "Ocurrió un error al confirmar la firma.",
            willOpen: zIndexFix,
          });
        } finally {
          setLoading(false);
        }
      }
    });
  };

  return (
    <>
      <button
        className="btn btn-light btn-lg"
        onClick={handleOpenModalTest}
        title="Confirmar Firma Cliente"
        style={{ padding: "5px 5px", fontSize: "10px" }}
      >
        Confirmar Firma
      </button>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Confirmar Firma"
        style={{ overlay: { zIndex: 2000 } }}
      >
        <button
          onClick={closeModal}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            background: "#a4a5a5",
            color: "white",
            border: "none",
            borderRadius: "50%",
            width: "70px",
            height: "70px",
            fontSize: "16px",
            fontWeight: "bold",
            cursor: "pointer",
            zIndex: 3000,
          }}
        >
          cerrar
        </button>
        <Header />

        <Container className="mt--7" fluid>
          <Row>
            <Col>
              <Card className="shadow">
                <CardHeader className="border-0 text-center">
                  <h3 className="heading-small text-muted mb-4">
                    Confirmar Firma del Contrato
                  </h3>
                </CardHeader>
                <CardBody>
                  <div className="text-center">
                    <button
                      className="btn btn-primary btn-user btn-block"
                      onClick={confirmarFirma}
                      disabled={isLoading}
                    >
                      {isLoading ? "Confirmando..." : "Confirmar Firma"}
                    </button>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </ReactModal>
    </>
  );
};

export default ContratosFirmadosCliente;
